import { BackdropCircularProgress, RouterLinkButton } from "@websential/cosmic";
import { Box, Grid, useTheme } from "@mui/material";
import {
  INITIAL_PAGE_SIZE,
  ROWS_PER_PAGE_PER_OPTIONS,
  SEARCH_DEBOUNCE_DELAY_IN_SECONDS,
} from "../../../common/constants";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { EmptyAccountantList } from "../../../components/Accountant/EmptyAccountantList";
import { IAppState } from "../../../store/reducers";
import { IGetListRequest } from "../../../models";
import { PrimeDataGrid } from "../../../components/PrimeDataGrid";
import { ReportsService } from "../../../services/ReportsService";
import { setSelectedActivityLogActions } from "../../../store/actions/activityLogActions";
import { setSelectedStickyNavBar } from "../../../store/actions/stickyNavBarActions";
import { toSnake } from "../../../common/methods";
import { useNavigate } from "react-router-dom";
import { useRemoveQueriesOnUnmount } from "../../../common/Common";

// import { EnhancedDDLBulkAction } from "@websential/ws-react-ui/lib/components/EnhancedDDLBulkAction";
// import { EnhancedDialog } from "@websential/ws-react-ui/lib/components/EnhancedDialog";
// import { ErrorState } from "@websential/ws-react-ui/lib/components/ErrorState/ErrorState";
// import { StatusChip } from "@websential/ws-react-ui/lib/components/StatusChip";








// import PrimeDataGrid from "./PrimeDataGrid";






export interface IT4AReport { }
const T4A_REPORT_LIST_QUERY_KEY = "t4a-report-list"

const useT4AReport = (
  clientId: string,
  taxYear: number,
  params: IGetListRequest
) =>
  useQuery({
    queryKey: [T4A_REPORT_LIST_QUERY_KEY, params],
    queryFn: (data) => {
      return ReportsService.getT4AReportNew(clientId, taxYear, params);
    },
    staleTime: 0,              // always stale
    gcTime: 0,                 // no cache persistence
    refetchOnMount: "always",  // always refetch
    refetchOnWindowFocus: false,
  });


export const T4AReport: React.FC<IT4AReport> = () => {
  const dispatch = useDispatch();
  const { id } = useSelector((state: IAppState) => state.client);
  const taxYear = useSelector((state: IAppState) => state.taxYear.year);
  const theme = useTheme();
  const navigate = useNavigate();

  const [queryParams, setQueryParams] = useState<IGetListRequest>({
    search_query: "",
    order_by: "resource.firstName",
    order_direction: "asc",
    page: 1,
    size: INITIAL_PAGE_SIZE,
  });

  const { isLoading, data } = useT4AReport(id, taxYear, queryParams);
  const T4AReportList: any = data;


  //Whenever Axios call is loading data it will effct on loading either slipList is undefined or not
  const [isAxiosCallLoading, setIsAxiosCallLoading] = useState(false);
  useEffect(() => {
    if (isLoading) {
      setIsAxiosCallLoading(true)
      setTimeout(() => {
        setIsAxiosCallLoading(false)
      }, 1000)
    } else {
      setIsAxiosCallLoading(true)
      setTimeout(() => {
        setIsAxiosCallLoading(false)
      }, 1000)
    }
  }, [isLoading])


  const { message, componentState } = useSelector(
    (state: IAppState) => state.viewState
  );

  const [openDialog, setDialogOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [statusValue, setStatusValue] = useState("");
  const [apiAction, setApiAction] = useState("");
  const [emptyList, setEmptyList] = useState(false);

  const onRequestParamsChange = useCallback((requestParams: any) => {

    let dispatchParams = {
      search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
      order_by: requestParams.sortField && requestParams.sortField === "resource.name" ? "resource.firstName" : requestParams.sortField ? requestParams.sortField : "resource.firstName",
      order_direction: requestParams.sortOrder
        ? requestParams.sortOrder
        : "asc",
      page: requestParams.page + 1,
      size: requestParams.rows,
    };
    // if (requestParams.sort) {
    //   const [sortBy, sortDirection] = requestParams.sort.split(",");
    //   dispatchParams.order_by = toSnake(sortBy);
    //   dispatchParams.order_direction = sortDirection;
    // }

    setQueryParams(dispatchParams);
  }, []);

  const onRowEditClicked = useCallback((params: any) => {
    alert(`Edit row with ID: ${params.row.id} has been clicked!`);
    // let path = `/T4As/setup/${params.row.id}`;
    // navigate(path);
  }, []);

  const onCloseHandler = () => {
    setDialogOpen(false);
  };

  const callAction = () => {
    if (apiAction === "delete") {
      alert(`Delete row with ID: ${selectedIds} has been clicked!`);
      // TODO api call for delete
    } else if (apiAction === "updateStatus") {
      alert(`action need to trigger : ${apiAction}`);
      // TODO api call for update status
    }
    setDialogOpen(false);
  };

  const onRowDeleteClicked = useCallback((params: any) => {
    setDialogOpen(true);
    setApiAction("delete");
    setSelectedIds(params.row.id);
    alert(`Delete row with ID: ${params.row.id} has been clicked!`);
  }, []);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setStatusValue(event.target.value as string);
    setApiAction("updateStatus");
    setDialogOpen(true);
  };

  const selectionToolbar = useCallback((selectedItems: any) => {
    setSelectedIds(selectedItems);
    if (selectedItems.length) {
      return (
        <Box sx={{ marginTop: theme.spacing(1) }}>
          {"Bulk Action Drop Down List"}
          {/* <EnhancedDDLBulkAction
            label="Status"
            value={statusValue}
            onChangeHandler={handleChange}
            options={[
              { name: "Active", value: "1" },
              { name: "Inactive", value: "2" },
            ]}
            testId="status-dd"
          /> */}
        </Box>
      );
    }
    return (
      <Box sx={{ marginTop: theme.spacing(1) }}>
        <RouterLinkButton
          to="/billing-profile/setup"
          text="Add Billing Profile"
        />
      </Box>
    );
  }, []);

  // if (isLoading) {
  //   return (
  //     <CircularProgress
  //       size={24}
  //       data-testid="circular-progress"
  //       className={classes.loader}
  //     />
  //   );
  // }

  const rowsWithTwoDecimalNumbers = T4AReportList !== undefined && T4AReportList?.items?.t4aReport && T4AReportList?.items?.t4aReport.map((item: any) => {
    return {
      ...item,
      slipData: {
        ...item.slipData,
        pensionOrSuperannuation: parseFloat(item.slipData.pensionOrSuperannuation).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        lumpSumPayments: parseFloat(item.slipData.lumpSumPayments).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        lumpSumPaymentsOther: parseFloat(item.slipData.lumpSumPaymentsOther).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        selfEmployedCommissions: parseFloat(item.slipData.selfEmployedCommissions).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        incomeTaxDeducted: parseFloat(item.slipData.incomeTaxDeducted).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        annuities: parseFloat(item.slipData.annuities).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        annuitiesOther: parseFloat(item.slipData.annuitiesOther).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        fees: parseFloat(item.slipData.fees).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      },
      resource: {
        ...item.resource,
        payeeType: item.resource.payeeType === true ? "Personal" : item.resource.payeeType === false ? "Business" : null,
      },
      // otherInformation: {
      //     // ...item.otherInformation,
      //     [0 + "_label_0"]: item.otherInformation["0_label_0"],
      //     [0 + "_amount_0"]: item.otherInformation["0_amount_0"] && parseFloat(item.otherInformation["0_amount_0"]).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      //     [1 + "_label_1"]: item.otherInformation["1_label_1"],
      //     [1 + "_amount_1"]: item.otherInformation["1_amount_1"] && parseFloat(item.otherInformation["1_amount_1"]).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      //     [2 + "_label_2"]: item.otherInformation["2_label_2"],
      //     [2 + "_amount_2"]: item.otherInformation["2_amount_2"] && parseFloat(item.otherInformation["2_amount_2"]).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      //     [3 + "_label_3"]: item.otherInformation["3_label_3"],
      //     [3 + "_amount_3"]: item.otherInformation["3_amount_3"] && parseFloat(item.otherInformation["3_amount_3"]).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      // }
    }
  });
  // const maxObjects = 17;
  // const updateColumnswith4OI = columns && columns.slice(0, maxObjects)
  const columnsWithTwoDecimalNumbers = T4AReportList && T4AReportList.headerColumns && T4AReportList.headerColumns.map((item: any) => {
    return {
      ...item,
      // footer: item.footer !== null && typeof(item.footer) !== "string" ? parseFloat(item.footer).toFixed(2) : item.footer
      footer: item.footer !== null && item.footer !== "" && item.footer !== "Total" ? parseFloat(item.footer).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : item.footer
    }
  });

  useEffect(() => {
    dispatch(setSelectedActivityLogActions({
      entityId1: '',
      entityId2: '',
      entityId3: '',
      screenName: '',
      companyName: '',
      activityType: "",
      activityLogVisibility: false
    }));
    dispatch(setSelectedStickyNavBar({ isSticky: false }));
  }, [])

  // reset data after leaves component
  useRemoveQueriesOnUnmount([T4A_REPORT_LIST_QUERY_KEY]);

  return emptyList ? (
    <EmptyAccountantList />
  ) : (
    <Grid
      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
      sx={{ width: "100%", overflow: "hidden" }}
    >
      {/* <EnhancedDialog
        dialogTitle="Please Confirm"
        key="dialog-box"
        testId="dialog"
        onCloseHandler={onCloseHandler}
        open={openDialog}
        dialogContent={
          <Typography variant="subtitle1">Are you sure?</Typography>
        }
        dialogAction={
          <Grid>
            <Button
              autoFocus
              variant="contained"
              onClick={onCloseHandler}
              color="default"
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              autoFocus
              variant="contained"
              onClick={callAction}
              color="primary"
              className={classes.button}
            >
              ok
            </Button>
          </Grid>
        }
      /> */}
      {/* <EnhancedDataGrid
        columns={T4AReportList ? T4AReportList.headerColumns : []}
        rows={T4AReportList?.items?.t4AReport}
        // total={T4AReportList?.items[0]?.total}
        // selectionEnabled={false}
        // autoHeight={false}
        allowSearching={true}
        selectionToolbar={selectionToolbar}
        onRowEditClicked={onRowEditClicked}
        onRowDeleteClicked={onRowDeleteClicked}
        // initialPage={0}
        disableColumnMenu={true}
        showRowActionsColumn={false}
        autoPageSize={false}
        showIndexColumn={true}
        testId="data-role-list-grid"
        sortingMode="server"
        filterMode="server"
        paginationMode="server"
        onRequestParamsChange={onRequestParamsChange}
        totalRowsCount={T4AReportList?.total}
        isLoading={isLoading}
        rowIdGetter={(row) => row.id}
        initialPageSize={INITIAL_PAGE_SIZE}
        rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
        searchDebouncingDelay={SEARCH_DEBOUNCE_DELAY_IN_SECONDS}
        shouldMask={false}
      /> */}
      <BackdropCircularProgress
        open={
          isLoading
        }
        testId="loading"
      />
      <PrimeDataGrid
        rows={T4AReportList !== undefined && rowsWithTwoDecimalNumbers ? rowsWithTwoDecimalNumbers : []}
        columns={T4AReportList && columnsWithTwoDecimalNumbers ? columnsWithTwoDecimalNumbers : []}
        showIndexColumn={true}
        showChecboxColumn={false}
        showSettingColumn={false}
        totalRecords={T4AReportList && T4AReportList.total ? T4AReportList.total : 0}
        initialPageSize={INITIAL_PAGE_SIZE}
        onRequestParamsChange={onRequestParamsChange}
        isLoading={isLoading || isAxiosCallLoading}
        rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
        searchFieldPlaceholder={"Search by Employee Name..."}
        tableScrollHeight={true}
      />
    </Grid>
  );
};
